import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectCurrentToken,
  selectCurrentError,
  selectCurrentUser,
} from "../../redux-toolkit/features/auth/authSlice";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import "./Login.css";
import React, { useMemo } from "react";
import { consumePostLoginRedirect } from "../../utils/postLoginRedirect";

export const RequireAuth = () => {
  const token = useSelector(selectCurrentToken);
  const user = useSelector(selectCurrentUser);
  const error = useSelector(selectCurrentError);
  const nextPath = useMemo(() => {
    if (user?.role === "IT") return "/super-admin";
    if (!token || error) return "/quest";
    return consumePostLoginRedirect("/quest");
  }, [token, error, user?.role]);

  return (
    <>
      {token === null && !error ? (
        <div className="reqAuth">
          <Box sx={{ width: '30%' }}>
            <LinearProgress />
          </Box>
        </div>
      ) : (
        <>
          {!error && <Navigate to={nextPath} />}
          {error && <Navigate to={'/login'} />}
        </>
      )}
    </>
  );
};
